<template>
    <b-card title="Filters" class="text-center" title-tag="h5">
        <b-card-body>
            <b-row class="mt-12">
                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-orderType"
                        label="Activity Type"
                        label-for="input-orderType"
                        label-cols="3"
                    >
                        <b-form-select
                            id="input-orderType"
                            v-model="orderFilter.type"
                            value-field="id"
                            text-field="name"
                            :options="orderTypes"
                        >
                            <template #first>
                                <b-form-select-option :value="null"
                                    >-- Any Type --</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>

                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-officer"
                        label="Officer"
                        label-for="input-officer"
                        label-cols="3"
                    >
                        <b-form-select
                            id="input-officer"
                            v-model="orderFilter.driver_id"
                            value-field="id"
                            text-field="name"
                            :options="officers"
                            :disabled="disabledOfficers"
                        >
                            <template #first>
                                <b-form-select-option :value="null"
                                    >-- Any Officer --</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>

                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-due_from"
                        label="Due From"
                        label-for="input-due_from"
                        label-cols="3"
                    >
                        <b-form-input
                            type="date"
                            id="input-due_from"
                            :max="orderFilter.due_to"
                            v-model="orderFilter.due_from"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-due_to"
                        label="Due To"
                        label-for="input-due_to"
                        label-cols="3"
                    >
                        <b-form-input
                            type="date"
                            :min="orderFilter.due_from"
                            id="input-due_to"
                            v-model="orderFilter.due_to"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-completion-date_from"
                        label="Complete From"
                        label-for="input-completion-date_from"
                        label-cols="3"
                    >
                        <b-form-input
                            type="date"
                            :max="orderFilter.completion_date_to"
                            id="input-completion-date_from"
                            v-model="orderFilter.completion_date_from"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-completion-date_to"
                        label="Complete To"
                        label-for="completion-date_to"
                        label-cols="3"
                    >
                        <b-form-input
                            type="date"
                            :min="orderFilter.completion_date_from"
                            id="completion-date_to"
                            v-model="orderFilter.completion_date_to"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-status"
                        label="Order Status"
                        label-for="input-status"
                        label-cols="3"
                    >
                        <b-form-select
                            id="input-status"
                            v-model="orderFilter.status"
                            value-field="id"
                            text-field="name"
                            :options="status"
                        >
                            <template #first>
                                <b-form-select-option :value="null">
                                    --Select Status--
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-status"
                        label="Role"
                        label-for="input-status"
                        label-cols="3"
                    >
                        <b-form-select
                            id="input-role_id"
                            v-model="orderFilter.role_id"
                            :options="roles"
                            text-field="name"
                            value-field="id"
                            required
                            trim
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled
                                    >--Select Role--</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col md="6" cols="12">
                    <b-form-group
                        label="Completed"
                        label-cols="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-group-completed"
                            v-model="orderFilter.completed"
                            :options="completedValues"
                            :aria-describedby="ariaDescribedby"
                            name="radio-completed"
                        >
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>

                <b-col md="6" cols="12">
                    <b-form-group
                        label="Updates"
                        label-cols="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-group-updated"
                            v-model="orderFilter.is_updated"
                            :options="changedValues"
                            :aria-describedby="ariaDescribedby"
                            name="radio-updated"
                        >
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-card sub-title="Review">
                        <b-row>
                            <b-col md="6" cols="12">
                                <b-form-select
                                    id="input-checkoff"
                                    v-model="orderFilter.checkoff_type_id"
                                    value-field="id"
                                    text-field="name"
                                    :options="checkoffTypes"
                                >
                                    <template #first>
                                        <b-form-select-option :value="null"
                                            >-- Any Review
                                            --</b-form-select-option
                                        >
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="6" cols="12">
                                <b-form-radio-group
                                    :disabled="!orderFilter.checkoff_type_id"
                                    id="radio-group-checkoff_completed"
                                    v-model="orderFilter.checkoff_completed"
                                    :options="completedValues"
                                    name="radio-checkoff_completed"
                                >
                                </b-form-radio-group>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-queryfilters',
    mixins: [permissionsMixins],

    props: [
        'orderTypes',
        'checkoffTypes',
        'officers',
        'value',
        'disabledOfficers',
    ],
    data() {
        return {
            status: [
                { id: 1, name: 'Completed' },
                { id: 2, name: 'Processing' },
                { id: 3, name: 'Pending' },
                // Add more options as needed
            ],
            // Other data properties
        }
    },
    computed: {
        roles() {
            return this.$store.state.roles.items
        },
        orderFilter: {
            // getter
            get() {
                console.log('...........', this.value)
                return this.value
            },
            // setter
            set(val) {
                if (!val.checkoff_type_id) {
                    val.checkoff_completed = null
                }
                val.completion_date_from
                this.$emit('input', val)
            },
        },
        completedValues() {
            return [
                { value: null, text: 'Any' },
                { value: 1, text: 'Yes' },
                { value: 2, text: 'No' },
            ]
        },
        changedValues() {
            return [
                { value: null, text: 'All' },
                { value: 1, text: 'Changed' },
                { value: 2, text: 'Unchanged' },
            ]
        },
    },
    created() {
        this.$store.dispatch('roles/fetchAll')
    },
    mounted() {
        // this.$store.dispatch('orders/fetchDrivers')
        //init remote filters
    },
    methods: {},
}
</script>
